import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { medicationsTypesActions, searchTableActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class MedicationsTypes extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newMedicationType, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Tipos de Medicamentos'}
          classes={classes}
          newResource={newMedicationType}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'tiposmedicamentos'}
        />
        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.medicationsTypes.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(medicationsTypesActions.openModal())
    },
    closeModal: () => {
      dispatch(medicationsTypesActions.closeModal())
    },
    newMedicationType: medicationType => {
      dispatch(medicationsTypesActions.newFormMedicationType(medicationType))
    },
    resetState: () => {
      dispatch(medicationsTypesActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(MedicationsTypes))



// WEBPACK FOOTER //
// ./src/containers/MedicationsTypes/index.js